import Blacklist from "@/store/api/data/Blacklist";

export default {
    state: {
        blacklist: []
    },
    mutations: {
        setBlacklist(state, blacklist) {
            state.blacklist = blacklist;
        }
    },
    actions: {
        loadBlacklist({ commit }) {
            return new Promise((resolve, reject) => {
                Blacklist.getAll().then(response => {
                    if (response.data.length === 0) {
                        reject("no data");
                    } else {
                        commit("setBlacklist", response.data);
                        resolve(response.data);
                    }
                });
            });
        },
        async addToBlacklist({ dispatch }, blacklistPzns) {
            await Blacklist.addTo(blacklistPzns);
            dispatch("loadBlacklist");
            dispatch("loadArticles");
        },
        async deleteFromBlacklist({ dispatch }, blacklist) {
            await Blacklist.deleteFrom(blacklist);
            dispatch("loadBlacklist");
            dispatch("loadArticles");
        }
    }
};
